module.exports = __webpack_public_path__ + "static/img/wdjc1-3.c8eef45.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdjc1-3.png
// module id = 882
// module chunks = 0